module.exports = __webpack_public_path__ + "static/thumb-0-d57f17ae0ed2aa15756c66977ba94921.jpg";